<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">add_circle</v-icon>
            {{ proxyData ? 'Edit' : 'Add a New' }}  Proxy
          </span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form_proxy" data-vv-scope="form_proxy" lazy-validation>
            <v-layout row wrap>
              <v-flex xs2 pr-2>
                <v-select
                  v-model="form.schema"
                  :items="schemaSelect"
                  item-text="name"
                  item-value="id"
                  label="Schema"
                ></v-select>
              </v-flex>
              <v-flex xs10 pl-2>
                <v-text-field
                  v-model="form.address"
                  label="Address*"
                  :rules="addressRules"
                  hint="example.com or 111.111.111.111"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="ports"
                  v-validate="'required'"
                  data-vv-name="form_proxy.ports"
                  :error-messages="errors.collect('form_proxy.ports')"
                  :filter="filter"
                  :hide-no-data="!search"
                  :items="items"
                  :search-input.sync="search"
                  hide-selected
                  label="Add port*"
                  multiple
                  small-chips
                  hint="The proxy will be created for each port"
                  :persistent-hint="true"
                  type="number"
                  min="0"
                >
                  <template slot="no-data">
                    <v-list-tile >
                      <span class="subheading">Create</span>
                      <v-chip
                        @click="addNewPortClick(search)"
                        color="primary white--text"
                        label
                        small
                      >
                        {{ search }}
                      </v-chip>
                    </v-list-tile>
                  </template>
                  <template
                    v-if="item === Object(item)"
                    slot="selection"
                    slot-scope="{ item, parent, selected }"
                  >
                    <v-chip
                      color="primary white--text"
                      :selected="selected"
                      label
                      small
                    >
                      <span class="pr-2">
                        {{ item.text }}
                      </span>
                      <v-icon
                        small
                        @click="parent.selectItem(item);"
                      >close</v-icon>
                    </v-chip>
                  </template>
                  <template
                    slot="item"
                    slot-scope="{ index, item }"
                  >
                    <v-list-tile-content @click="form.ports.push(parseInt(item.text))">
                      <v-text-field
                        v-if="editing === item"
                        v-model="editing.text"
                        autofocus
                        flat
                        background-color="transparent"
                        hide-details
                        solo
                        @keyup.enter="edit(index, item)"
                      ></v-text-field>
                      <v-chip
                        v-else
                        color="primary white--text"
                        dark
                        label
                        small
                      >
                        {{ item.text }}
                      </v-chip>
                    </v-list-tile-content>
                    <v-spacer></v-spacer>
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex xs12 sm6 pr-3>
                <v-text-field
                  v-model="form.username"
                  label="Username"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 pl-3>
                <v-text-field
                  v-model="form.password"
                  label="Password"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-subheader class="subheading pt-4 pl-0">Cooldown:</v-subheader>
              </v-flex>
              <v-flex xs3 pr-3>
                <v-text-field
                  v-model="form.cooldown"
                  label="Usage"
                  type="number"
                  v-validate="'numeric|max_value:10000000'"
                  data-vv-name="form_proxy.cooldown"
                  :error-messages="errors.collect('form_proxy.cooldown')"
                  min=0
                  max=10000000
                ></v-text-field>
              </v-flex>
              <v-flex xs3 px-1>
                <v-text-field
                  v-model="form.cooldown_blocked"
                  label="Blocked"
                  type="number"
                  v-validate="'numeric|max_value:10000000'"
                  data-vv-name="form_proxy.cooldown_blocked"
                  :error-messages="errors.collect('form_proxy.cooldown_blocked')"
                  min=0
                  max=10000000
                ></v-text-field>
              </v-flex>
              <v-flex xs3 pl-3>
                <v-text-field
                  v-model="form.cooldown_dead"
                  label="Dead"
                  type="number"
                  v-validate="'numeric|max_value:10000000'"
                  data-vv-name="form_proxy.cooldown_dead"
                  :error-messages="errors.collect('form_proxy.cooldown_dead')"
                  min=0
                  max=10000000
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pr-3>
                <v-text-field
                  v-model="form.priority"
                  label="Priority"
                  type="number"
                  v-validate="'numeric|max_value:10000'"
                  data-vv-name="form_proxy.priority"
                  :error-messages="errors.collect('form_proxy.priority')"
                  min=0
                  max=10000
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pl-3>
                <v-text-field
                  v-model="form.max_uses_per_day"
                  label="Max uses per day"
                  type="number"
                  v-validate="'numeric|max_value:10000000'"
                  data-vv-name="form_proxy.max_uses_per_day"
                  :error-messages="errors.collect('form_proxy.max_uses_per_day')"
                  min=0
                  max=10000000
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  v-model="form.enabled"
                  color="primary"
                  label="Enable"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveProxy()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'ProxyModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['proxyDialog', 'proxyData', 'loading'],
  data () {
    return {
      dialog: this.proxyDialog,
      form: {
        schema: this.proxyData ? this.proxyData.schema : 0,
        address: this.proxyData ? this.proxyData.address : '',
        port: this.proxyData ? this.proxyData.port : 0,
        ports: this.proxyData ? [this.proxyData.port] : [],
        username: this.proxyData ? this.proxyData.username : '',
        password: this.proxyData ? this.proxyData.password : '',
        cooldown: this.proxyData ? this.proxyData.cooldown : 120,
        cooldown_blocked: this.proxyData ? this.proxyData.cooldown_blocked : 1200,
        cooldown_dead: this.proxyData ? this.proxyData.cooldown_dead : 2400,
        max_uses_per_day: this.proxyData ? this.proxyData.max_uses_per_day : 120,
        priority: this.proxyData ? this.proxyData.priority : 0,
        enabled: this.proxyData ? this.proxyData.enabled : true
      },
      editing: null,
      index: -1,
      items: [
        { header: 'Select a port or add one' },
        { text: '80' }
      ],
      nonce: 1,
      ports: [],
      search: null,
      addressRules: [
        v => !!v || 'Address is required',
        v => (v && /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/.test(v)) || 'IP or domain name'
      ],
      dictionary: {
        en: {
          custom: {
            'form_proxy.schema': {
              required: 'Schema required'
            },
            'form_proxy.address': {
              required: 'Address required'
            },
            'form_proxy.ports': {
              required: 'At least one port required'
            },
            'form_proxy.cooldown': {
              max_value: 'Cooldown should be less then 10000000',
              numeric: 'Only numbers'
            },
            'form_proxy.cooldown_blocked': {
              max_value: 'Blocked cooldown should be less then 10000000',
              numeric: 'Only numbers'
            },
            'form_proxy.cooldown_dead': {
              max_value: 'Dead cooldown should be less then 10000000',
              numeric: 'Only numbers'
            },
            'form_proxy.max_uses_per_day': {
              max_value: 'Max uses per day should be less then 10000000',
              numeric: 'Only numbers'
            },
            'form_proxy.priority': {
              max_value: 'Priority should be less then 10000',
              numeric: 'Only numbers'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')

    this.items = this.items.concat(this.ports)
  },
  computed: {
    schemaSelect: function () {
      return this.$store.state.metadata.schemaSelect
    }
  },
  watch: {
    ports (val, prev) {
      if (val.length === prev.length || !val.length || (val[val.length - 1] && typeof val[val.length - 1] === 'string' && !val[val.length - 1].trim())) return

      this.ports = val.map(v => {
        if (typeof v === 'string' && v.trim()) {
          v = { text: v }
          this.items.push(v)
          // this.form.ports.push(parseInt(v.text))
          this.nonce++
        }
        return v
      })
    },
    proxyDialog: {
      handler () {
        this.dialog = this.proxyDialog
        if (this.dialog && !this.proxyData) {
          this.clearForm()
        }
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('proxyDialog', this.dialog)
      }
    },
    proxyData: {
      handler () {
        this.form.schema = this.proxyData ? this.proxyData.schema : 0
        this.form.address = this.proxyData ? this.proxyData.address : ''
        this.form.port = this.proxyData ? this.proxyData.port : 0
        this.form.ports = this.proxyData ? [this.proxyData.port] : []
        this.form.username = this.proxyData ? this.proxyData.username : ''
        this.form.password = this.proxyData ? this.proxyData.password : ''
        this.form.cooldown = this.proxyData ? this.proxyData.cooldown : 120
        this.form.cooldown_blocked = this.proxyData ? this.proxyData.cooldown_blocked : 1200
        this.form.cooldown_dead = this.proxyData ? this.proxyData.cooldown_dead : 2400
        this.form.max_uses_per_day = this.proxyData ? this.proxyData.max_uses_per_day : 120
        this.form.priority = this.proxyData ? this.proxyData.priority : 0
        this.form.enabled = this.proxyData ? this.proxyData.enabled : true

        if (this.proxyData) {
          let port = { text: this.proxyData.port }
          if (!this.items.filter(e => e.text === this.proxyData.port).length) {
            this.items.push(port)
          }
          if (!this.ports.filter(e => e.text === this.proxyData.port).length) {
            this.ports.push(port)
          }
        } else {
          this.ports = []
        }
      }
    }
  },
  methods: {
    saveProxy () {
      this.$validator.validateAll('form_proxy').then(res => {
        if (res) {
          if (this.$refs.form_proxy.validate()) {
            this.prepareFormData()

            this.$parent.$emit('loading', true)
            this.proxyData ? this.editProxies() : this.addProxies()
          }
        }
      })
    },
    prepareFormData () {
      this.form.cooldown = parseInt(this.form.cooldown)
      this.form.cooldown_blocked = parseInt(this.form.cooldown_blocked)
      this.form.cooldown_dead = parseInt(this.form.cooldown_dead)
      this.form.max_uses_per_day = parseInt(this.form.max_uses_per_day)
      this.form.priority = parseInt(this.form.priority)

      this.form.ports = this.ports.map(v => {
        return parseInt(v.text)
      })
    },
    addProxies () {
      this.$store.dispatch('ADD_PROXY', this.form).then(res => {
        this.$parent.$emit('loading', false)
        this.$parent.$emit('updateProxiesList')
        this.$store.dispatch('GET_COUNTS')
        this.closeModal()
      }, err => {
        console.log('login error', err)
        this.$parent.$emit('loading', false)
        this.$toasted.show('ADD_PROXY ERROR: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    editProxies () {
      this.form.port = this.form.ports[0]
      this.editProxy()

      if (this.form.ports.length > 1) {
        this.form.ports.shift()
        this.addProxies()
      }
    },
    editProxy () {
      this.$store.dispatch('EDIT_PROXIES', { ids: [this.proxyData.id], ...this.form }).then(res => {
        this.$parent.$emit('loading', false)
        this.$parent.$emit('updateProxiesList')
        this.$store.dispatch('GET_COUNTS')
        this.closeModal()
      }, err => {
        console.log('EDIT_PROXIES ERROR', err)
        this.$parent.$emit('loading', false)
        this.$toasted.show('EDIT_PROXIES ERROR: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    closeModal () {
      this.dialog = false
      this.clearForm()
    },
    removePort (item) {
      var index = this.form.ports.indexOf(parseInt(item.text))
      if (index > -1) {
        this.form.ports.splice(index, 1)
      }
    },
    keywordsToArray (strKeywords) {
      let arrKeywords = []

      // check if there are some lines
      var match = /\r|\n/.exec(strKeywords)

      if (match) {
        let arrLines = strKeywords.match(/[^\r\n]+/g)
        arrKeywords = arrLines.map((line) => {
          return line.split(',').map((keyword) => { return keyword.trim() })
        })
        // join arrays in array
        arrKeywords = [].concat.apply([], arrKeywords)
      } else {
        arrKeywords = strKeywords.split(',').map((keyword) => { return keyword.trim() })
      }

      // remove empty values
      arrKeywords = arrKeywords.filter((keyword) => {
        return keyword != null && keyword !== ''
      })

      return arrKeywords
    },
    clearForm () {
      this.form = {
        schema: 0,
        address: '',
        ports: [],
        username: '',
        password: '',
        cooldown: 120,
        cooldown_blocked: 1200,
        cooldown_dead: 2400,
        max_uses_per_day: 120,
        priority: 0,
        enabled: true
      }
      this.ports = []
      setTimeout(() => {
        this.$validator.errors.clear('form_proxy')
        this.$refs.form_proxy.resetValidation()
      }, 200)
    },
    edit (index, item) {
      if (!this.editing) {
        this.editing = item
        this.index = index
      } else {
        this.editing = null
        this.index = -1
      }
    },
    addNewPortClick (port) {
      // this.form.ports.push(parseInt(port))
      this.ports.push({ text: port })
      this.items.push({ text: port })
    },
    filter (item, queryText, itemText) {
      if (item.header) return false

      const hasValue = val => val != null ? val : ''

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/proxy-modal/ProxyModal.vue